/* =========================================================================
   TelemetryConfirmDialog — clean modal wrapper around ConfirmationDialog.tsx
   ========================================================================= */

import React from 'react';
import ConfirmationDialog from '../../../../../CommonComponents/confirmation_dialog/ConfirmationDialog';
import { ConfirmDialogState } from '../hooks/useTelemetryConfirm';

interface TelemetryConfirmDialogProps {
  state: ConfirmDialogState;
  onCancel: () => void;
  onConfirm: () => void;
}

export const TelemetryConfirmDialog: React.FC<TelemetryConfirmDialogProps> = ({
  state,
  onCancel,
  onConfirm,
}) => {
  if (!state.open) return null;

  return (
    <div id="telemetry-confirm-dialog-wrapper">
      <ConfirmationDialog
        type={state.type}
        open={state.open}
        title={state.title}
        description={state.description}
        confirm_button_text={state.confirmText}
        cancel_button_text={state.cancelText}
        confirm_loading_text={state.confirmLoadingText}
        loading={state.loading}
        onConfirm={onConfirm}
        onDiscard={state.onDiscardAction}
        onCancel={state.onCancelAction || onCancel}
      />
    </div>
  );
};

export default TelemetryConfirmDialog;
